import {PaginatedUrlVariant} from '../types';

const trimSlashes = (path: string) => {
  const withoutDuplicatedSlashes = path.replace(/\/\//g, '/');
  if (withoutDuplicatedSlashes === '/') {
    return withoutDuplicatedSlashes;
  }
  const withoutTrailingSlash = withoutDuplicatedSlashes.replace(/\/$/, '');
  return withoutTrailingSlash;
};

export const withPaginationSuffix = (
  basePath: string,
  pageNumber: number,
  variant: PaginatedUrlVariant,
) => {
  if (pageNumber === 1) {
    return basePath;
  }
  switch (variant) {
    case 'page-x': {
      return `${basePath}/page-${pageNumber}`;
    }
    case 'page/x': {
      return `${basePath}/page/${pageNumber}`;
    }
  }
};

export default function makeGetHref(
  basePath: string,
  variant: PaginatedUrlVariant,
  queryParams: URLSearchParams | undefined,
): (pageNumber: number) => string {
  if (!queryParams?.size) {
    return (pageNumber) =>
      trimSlashes(withPaginationSuffix(basePath, pageNumber, variant));
  }
  const queryString = queryParams.toString();

  return (pageNumber) =>
    `${trimSlashes(withPaginationSuffix(basePath, pageNumber, variant))}?${queryString}`;
}
